import type { FC } from 'react'

import { TransactionHistory } from '@pages/IntroducingBroker/Dashboard/TransactionHistory/TransactionHistory'
import { useWalletsWithLatestTransactions } from '@pages/IntroducingBroker/Dashboard/hooks/useWalletsWithLatestTransactions'

export const TransactionHistoryWidget: FC = () => {
  const { walletsWithLatestTransactions, isLoading } = useWalletsWithLatestTransactions()

  return (
    <TransactionHistory
      walletsWithLatestTransactions={walletsWithLatestTransactions}
      isLoading={isLoading}
    />
  )
}
